export const FETCH_PRODUCT = 'FETCH_PRODUCT'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js